import actionTypes from '../constants/action-types';
import type { Subscription } from '../types/subscription';
import type { PayloadAction } from '../types/actions';

function list(
  state: Subscription[] | null = null,
  action: PayloadAction<Subscription[]>
): Subscription[] | null {
  if (action.type === actionTypes.SET_SUBSCRIPTIONS) {
    return action.payload;
  }

  return state;
}

export default list;
